// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"166ecf63","285":"d30f5480","321":"ab6774c2","496":"cd348932","532":"3fa686b5","661":"74825ae7"}[chunkId] + ".chunk.js";
};